<template>
  <div>
    <table border="1" frame="cols" width="600" id="printTable">
      <tr>
        <th colspan="6" align="center">{{customerName}}维护工单</th>
      </tr>
      <tr align="center">
        <td width="130">报修科室</td>
        <td colspan="5">{{ obj.address }}</td>
      </tr>
      <tr align="center">
        <td>报修人</td>
        <td width="90">{{ obj.repairBy }}</td>
        <td width="90">故障分类</td>
        <td colspan="3">&#9744;硬件&#9744;软件&#9744;网络</td>
      </tr>
      <tr align="center">
        <td>报修时间</td>
        <td>{{ obj.repairTime }}</td>
        <td>完成时间</td>
        <td width="90">{{ obj.finishTime }}</td>
        <td width="90">服务历时</td>
        <td width="90"></td>
      </tr>
      <tr align="center">
        <td colspan="6">故障内容描述</td>
      </tr>
      <tr align="center" height="70">
        <td colspan="6">{{ obj.descr }}</td>
      </tr>
      <tr align="center">
        <td colspan="6">处理方案</td>
      </tr>
      <tr align="center" height="70">
        <td colspan="6">{{ this.mainContext }}</td>
      </tr>
      <tr align="center">
        <td>科室反馈</td>
        <td colspan="5">&#9744;已维修&#9744;已升级&#9744;已新增</td>
      </tr>
      <tr align="center">
        <td>费用</td>
        <td colspan="5"></td>
      </tr>
      <tr align="center">
        <td>报修科室签字</td>
        <td colspan="5"></td>
      </tr>
      <tr align="center">
        <td>信息科签字</td>
        <td colspan="2"></td>
        <td>服务日期</td>
        <td colspan="2">{{ obj.finishTime }}</td>
      </tr>
    </table>
    <el-button type="primary" @click="bindPrint">打印</el-button>
  </div>
</template>

<script>
import printJS from "print-js";
export default {
  props: {
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mainContext:"",
      obj: {},
      customerName:''
    };
  },
  mounted() {
    let MaintainerToken = global.$utils.data.get("","token");

    if (!MaintainerToken ){
      if (window.localStorage.getItem('token')=='{"data":""}'){
        return
      }

    }else {
      if (this.workId) {
        this.getInfo(this.workId);
      }

      this.getCustomerInfo();
    }
  },
  methods: {
    bindPrint() {
      printJS({
        printable: "printTable",
        type: "html",
        header: null,
        targetStyles: ["*"],
        style: "@page {margin:0 10mm}",
      });
    },
    async getInfo(item) {
      let id = item;
      try {
        let res = await $utils.api.load(`/admin/system/work/${id}`, {}, "GET");
        if (res.code === 200) {
          this.obj = res.data;
          let arr = res.data.sysWorkTracks;
          if (arr.length > 1) {
            for (let i = 0; i < arr.length; i++) {
              this.mainContext=this.mainContext +arr[i].maintainerContent+ ",";
            }
          }else {
            this.mainContext = arr[0].maintainerContent;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomerInfo() {

      // 加载详情数据
      let res = await $utils.api.load(
          `/admin/system/customer/getCustomerInfo`,
          {},
          "GET"
      );
      if (res && res.data) {
        this.customerName = res.data.customerName;
      }
    },
  },
};
</script>

<style scoped>
html {
  font-family: sans-serif;

  -ms-text-size-adjust: 100%;

  -webkit-text-size-adjust: 100%;
}

body {
  margin: 10px;
}

table {
  height: 400px;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 18px;
  margin: 50px 70px;
}

td,
th {
  padding: 0;
}

.pure-table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  border: 1px solid #cbcbcb;
}

.pure-table caption {
  color: #000;
  font: italic 85%/1 arial, sans-serif;
  padding: 1em 0;
  text-align: center;
}

.pure-table td,
.pure-table th {
  border-left: 1px solid #cbcbcb;
  border-width: 0 0 0 1px;
  font-size: inherit;
  margin: 0;
  overflow: visible;
  padding: 0.5em 1em;
}

.pure-table thead {
  background-color: #e0e0e0;
  color: #000;
  text-align: left;
  vertical-align: bottom;
}

.pure-table td {
  background-color: transparent;
}

.pure-table-bordered td {
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody > tr:last-child > td {
  border-bottom-width: 0;
}
</style>